import { useContext, useState } from "react";
import { Alert, Box, Grid } from "@mui/material";
import { ContextSession } from "../../services/ContextSession";
import { isSessionExpiredError, postHeader } from "../../services/http";
import FichaDni from "../RNP/fichadni.component";
import "./fichadni.component.css";

async function getDniData(dni, justificacion, token) {
  const json = { numinscripcion: dni, justificacion };
  const auth = `Bearer ${token}`;
  const url = "https://bei360.injupemp.gob.hn:8444/api/rnp/consulta/";
  return postHeader(url, json, auth);
}

export default function FichaPorNombres({ dniData, justificacion = "" }) {
  const sessi = useContext(ContextSession);
  const dnida = sessi.getVariable("dniDataPorNombre") || null;
  const [dniDataNombre, setDniDataNombre] = useState(dnida);
  const [detailError, setDetailError] = useState("");
  const { sessionData } = useContext(ContextSession);
  const [showDetails, setShowDetails] = useState(false);

  function formatData(fechadenacimiento) {
    if (fechadenacimiento) {
      return fechadenacimiento.substring(0, 10);
    }
    return "Fecha no disponible";
  }

  async function handleVerDetalle(numinscripcion) {
    try {
      setDetailError("");
      const token = sessionData.token;
      const data = await getDniData(numinscripcion, justificacion, token);
      setDniDataNombre(data);
      sessi.setVariable("dniDataPorNombre", data);
      setShowDetails(true);
    } catch (error) {
      if (isSessionExpiredError(error)) {
        return;
      }

      console.error("Error al realizar la consulta:", error);
      setDetailError(error?.payload?.error || error?.message || "No se pudo obtener el detalle.");
      setShowDetails(false);
    }
  }

  return (
    <>
      {dniData.length === 0 ? (
        <div>No se encontraron datos</div>
      ) : (
        <>
          <table className="tabla-dni">
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>#</th>
                <th style={{ textAlign: "center" }}>Nombre</th>
                <th style={{ textAlign: "center" }}>Identidad</th>
                <th style={{ textAlign: "center" }}>Fecha De Nacimiento</th>
                <th style={{ textAlign: "center" }}>Acción</th>
              </tr>
            </thead>
            <tbody>
              {dniData.map((persona, index) => (
                <tr key={index}>
                  <td style={{ textAlign: "center" }}>{index + 1}</td>
                  <td>{persona.nombres} {persona.primerapellido} {persona.segundoapellido}</td>
                  <td style={{ textAlign: "center" }}>{persona.numinscripcion}</td>
                  <td style={{ textAlign: "center" }}>{formatData(persona.fechadenacimiento)}</td>
                  <td style={{ textAlign: "center" }}>
                    <button
                      style={{ cursor: "pointer" }}
                      onClick={() => handleVerDetalle(persona.numinscripcion)}
                    >
                      Ver
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {detailError && (
            <Alert severity="warning" sx={{ mt: 2 }}>
              {detailError}
            </Alert>
          )}
          {showDetails && (
            <Grid>
              <Box marginTop={5}>
                <FichaDni dniData={dniDataNombre} />
              </Box>
            </Grid>
          )}
        </>
      )}
    </>
  );
}
